function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "22",
  height: "19",
  viewBox: "0 0 22 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.289.27H4.69A4.455 4.455 0 00.236 4.725v9.55a4.455 4.455 0 004.455 4.455h12.598a4.455 4.455 0 004.454-4.455v-9.55A4.455 4.455 0 0017.29.27zm-6.592 14.37H18.455l-2.681-4.642-1.983-3.434a.803.803 0 00-1.39 0L10.42 9.998 9.216 12.08l-.314-.545-1.096-1.902a.803.803 0 00-1.39 0L5.32 11.535 3.525 14.64h7.172zm-2.96-9.087a1.75 1.75 0 11-3.5 0 1.75 1.75 0 013.5 0z",
  fill: "#fff"
})));